var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("ID 접근 차단 안내")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "v-card--dialog__body text-center pt-10 pb-6"
  }, [_vm._v(" 5회 이상의 로그인 실패 기록이 확인 되었습니다. "), _c('br'), _vm._v(" 대한문고의 서비스 이용을 원하신다면 "), _c('br'), _vm._v(" 본인인증을 완료해주시기 바랍니다. "), _c('br')]), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "no-gutters": "",
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        var _vm$$refs$kcbCert, _vm$$refs$kcbCert$ope;

        (_vm$$refs$kcbCert = _vm.$refs['kcbCert']) === null || _vm$$refs$kcbCert === void 0 ? void 0 : (_vm$$refs$kcbCert$ope = _vm$$refs$kcbCert.open) === null || _vm$$refs$kcbCert$ope === void 0 ? void 0 : _vm$$refs$kcbCert$ope.call(_vm$$refs$kcbCert);
      }
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)], 1), _c('kcb-cert', {
    ref: "kcbCert",
    on: {
      "input": _vm.certify
    }
  }), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }